export const KeyLicenseTypes = {
  Offline: '0',
  OnlinePermanent: '1',
  OnlineTemporary: '2'
};

export const KeyLicenseTypeNames = {
  [KeyLicenseTypes.Offline]: 'Offline',
  [KeyLicenseTypes.OnlinePermanent]: 'Online permanent',
  [KeyLicenseTypes.OnlineTemporary]: 'Online temporary'
};

export const OnlineLicenseTypes = [KeyLicenseTypes.OnlinePermanent, KeyLicenseTypes.OnlineTemporary];



// WEBPACK FOOTER //
// ./src/common/keyLicenseTypes.js